module.exports = __webpack_public_path__ + "dist/media/ec_comp_cards.ce37aca5.svg";